import { Reglamento_copropiedad } from './../../../models/reglamento_copropiedad.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-reglamento_copropiedad",
    templateUrl: "./reglamento_copropiedad.component.html",
    styleUrls: ["./reglamento_copropiedad.component.css"],
    providers: [FormService]
})

export class Reglamento_copropiedadComponent {
    public rows = [];
    public actualRow;
    public reglamento_copropiedad: Reglamento_copropiedad;
    public form;
    public maxDate
    public  fech_reglamento_copropiedad;

    matcher = new FormService();


  constructor(public _formService: FormService, private fb:FormBuilder){

    this.maxDate = moment().toDate()

    this.form = new FormGroup({

        notaria_reg_copro: new FormControl(''),
        fecha_notaria: new FormControl({value :'', disabled : true}),
        cbr_reg_copro: new FormControl(''),
        registro_anio: new FormControl(''),
        fojas_reg_copro: new FormControl(''),
        numero: new FormControl(''),
        
        })

    if(!JSON.parse(localStorage.getItem("reglamento_copropiedad"))){
          localStorage.setItem("reglamento_copropiedad", JSON.stringify(this.rows));
    }else{
        this.rows = JSON.parse(localStorage.getItem("reglamento_copropiedad"));

        this.form.controls['notaria_reg_copro'].setValue(this.rows[0]?this.rows[0].notaria_reg_copro:false);
        this.form.controls['fecha_notaria'].setValue(this.rows[0]?new Date(this.rows[0].fecha_notaria):null);
        this.form.controls['cbr_reg_copro'].setValue(this.rows[0]?this.rows[0].cbr_reg_copro:'')
        this.form.controls['registro_anio'].setValue(this.rows[0]?this.rows[0].registro_anio:'')
        this.form.controls['fojas_reg_copro'].setValue(this.rows[0]?this.rows[0].fojas_reg_copro:'')
        this.form.controls['numero'].setValue(this.rows[0]?this.rows[0].numero:'')
       
      }
      

  }

  add_reglamento_copropiedad(event?: MatDatepickerInputEvent<Date>, type?){

    if(event){
        if(type == 'change' || type == 'input'){
        
        this.fech_reglamento_copropiedad = moment(event.value).format('DD/MM/YYYY')
    }
   } else {
       var temp = JSON.parse(localStorage.getItem("reglamento_copropiedad"))
       if(temp > 0){
           this.fech_reglamento_copropiedad = temp[0].fech_reglamento_copropiedad
       }
       
   }
    localStorage.setItem("reglamento_copropiedad",JSON.stringify([]));
      this.actualRow = localStorage.getItem("reglamento_copropiedad");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        notaria_reg_copro: this.form.value.notaria_reg_copro,
        fecha_notaria:this.fech_reglamento_copropiedad,
        cbr_reg_copro : this.form.value.cbr_reg_copro,
        registro_anio : this.form.value.registro_anio,
        fojas_reg_copro : this.form.value.fojas_reg_copro,
        numero : this.form.value.numero,

        
      })
      localStorage.setItem("reglamento_copropiedad", JSON.stringify(this.rows));
      console.log(this.reglamento_copropiedad)
  }

  delete_reglamento_copropiedad(id){
      for(let x = 0; x < this.rows.length; x++){
          if(id == x){
              this.rows.splice(x, 1);
              localStorage.setItem("reglamento_copropiedad", JSON.stringify(this.rows));
          }
      }
  }  
}